import React from 'react';
import ReactDOM from 'react-dom/client'; // Importação atualizada
import App from './App';
import './styles/style.css'; // Se você tiver estilos globais


const root = ReactDOM.createRoot(document.getElementById('root')); // Cria a raiz
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
